import React, { useEffect, useState } from 'react'
import { isEmpty } from 'libraries/lodash'
import Paper from '@material-ui/core/Paper'
import url from 'front-end-core/core/url'
import { COMMENTS } from 'constants/controllers'
import Actions from 'pages/comments/Actions'
import Pagination from 'pages/comments/Pagination'
import CommentsListContainer from 'redux/containers/pages/comments/CommentsListContainer'

const CommentsComponent = ({
  page,
  pageLength,
  comments: _comments,
  category,
  order,
  archived,
  users,
  privacy,
  preview,
  aol,
  setCommentsLoaded,
  setAnnotationsLoaded,
  commentMap,
  isQa
}) => {
  const [comments, setComments] = useState([])
  const [commentCount, setCommentCount] = useState(null)

  const sortLink = order => url(COMMENTS, { aol }, { category, order, users, privacy, archived })
  const getUrl = page => url(COMMENTS, { aol }, { category, page, order, users, privacy, archived, preview })

  useEffect(() => {
    setComments(_comments)
    setCommentCount(_comments.length)
  }, [_comments])

  useEffect(() => {
    if (isQa) {
      setCommentsLoaded(!isEmpty(commentMap) || commentCount >= 0)
      setAnnotationsLoaded(!isEmpty(commentMap) || commentCount >= 0)
    } else {
      setCommentsLoaded(true)
      setAnnotationsLoaded(true)
    }
  }, [isQa, commentCount, commentMap])

  return (
    <>
      {!isEmpty(comments) && (
        <Paper className='flex items-center justify-between bg-ice-blue ph4 pv4' classes={{ rounded: 'br0' }}>
          <Actions
            {...{ comments, category, page, pageLength, commentCount, sortValue: order || 'latest', preview, sortLink }}
            disabled
          />
        </Paper>
      )}
      <div className='ph6 mt6 mb8'>
        <CommentsListContainer {...{ comments, commentMap, page, pageLength, category, preview }} />
      </div>
      <div className='flex items-center justify-between bt-medium b--cadet-blue pt6'>
        <Pagination {...{ total: commentCount, page, pageLength, getUrl }} />
        {/* TODO: disable Actions until they are fixed */}
        <Actions disabled {...{ comments, category, page, preview, pageLength, commentCount }} />
      </div>
    </>
  )
}

export default CommentsComponent
